/* __next_internal_client_entry_do_not_use__ SellOnFaireLink auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandApplication from "@faire/web-api--source/routes/apply";
import brands from "@faire/web-api--source/routes/brands";
import React from "react";
import { useLocation } from "react-router-dom";
import { HeaderLink } from "../styled";
export var SellOnFaireLink = function() {
    var location = useLocation();
    return /*#__PURE__*/ _jsx(HeaderLink, {
        to: location.pathname.includes(brands()) ? brandApplication() : brands(),
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "3mF4JS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sell on Faire"
                }
            ]
        })
    });
};
